import { pList } from '../../../../api/models/.catalog';
import { ActionSubTypes } from '../../../ActionSubTypes';
import Api from '../../../../api/ApiWrapper';
import { IApiAction, IInputAction, IPromiseAction } from '../../../../models/ActionModels';
import ActionFunctions from '../../../core/ActionFunctions';
import { IError } from '../../../../models/StateModels';
import { rValue, rOyakEmlakVergileri } from '../../../../api/models/.catalog';

export const action_api_set_input = (body: pList | null | undefined): IInputAction<pList> =>
  ActionFunctions.action_api_set_input(ActionSubTypes.API_OYAKEMLAKVERGILERI, true, body);

export const action_async_start = (body: pList): IPromiseAction<pList> =>
  ActionFunctions.action_async_start_promise(
    ActionSubTypes.API_OYAKEMLAKVERGILERI,
    new Api.Stat.OyakEmlakVergiler().Request(body),
    false,
    true,
    body
  );

export const action_async_complete = (
  data: rValue<rOyakEmlakVergileri> | null | undefined,
  error: IError | null | undefined
): IApiAction<rOyakEmlakVergileri> =>
  ActionFunctions.action_async_complete_api<rOyakEmlakVergileri>(
    ActionSubTypes.API_OYAKEMLAKVERGILERI,
    data?.Value,
    error
  );
